<a class="quiet-link" href="/">
  <kendo-stacklayout class="link-wrapper" orientation="horizontal" gap="10px" [align]="{ vertical: 'bottom', horizontal: 'start' }">
    <span class="logo-wrapper">
      <img class="logo" [src]="getLogo()" [alt]="alt" />
    </span>
    <h4 class="logo-text">UNITY</h4>
  </kendo-stacklayout>
</a>
